module.exports = __webpack_public_path__ + "static/media/TheFutureIsNow1.7f742d88.png";